export default __webpack_public_path__ + "static/media/bg-1.50b5d641.jpg";